import { render } from "./receiver-account.vue?vue&type=template&id=1cc33ce3"
import script from "./receiver-account.vue?vue&type=script&lang=ts"
export * from "./receiver-account.vue?vue&type=script&lang=ts"
script.render = render

export default script